// DS: MO3.9
import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import useDeviationSaleDetails from '../../../../utils/hooks/useDeviationSaleDetails';
import s from './DeviationThumbDiscountLabel.scss';
const DeviationThumbDiscountLabel = ({ className, deviation, textVariant = 'up-to-x-off' })=>{
    const { t } = useTranslation();
    const { eligibleDiscount, formattedEligibleDiscountDollarAmount, allDiscounts } = useDeviationSaleDetails(deviation);
    let label;
    if (textVariant === 'up-to-x-off') {
        const maxPercentDiscount = Math.max(...allDiscounts.map((d)=>{
            var _d_amount;
            return ((_d_amount = d.amount) === null || _d_amount === void 0 ? void 0 : _d_amount.percent) || 0;
        }));
        if (maxPercentDiscount > 0) {
            label = t('deviationview.thumb.discountLabel.upToPercentOff', {
                percentage: maxPercentDiscount.toFixed(0)
            });
        }
    } else if (textVariant === 'sale-x-off') {
        var _eligibleDiscount_amount;
        if (eligibleDiscount === null || eligibleDiscount === void 0 ? void 0 : (_eligibleDiscount_amount = eligibleDiscount.amount) === null || _eligibleDiscount_amount === void 0 ? void 0 : _eligibleDiscount_amount.percent) {
            label = t('deviationview.thumb.discountLabel.salePercentOff', {
                percentage: eligibleDiscount.amount.percent.toFixed(0)
            });
        }
    } else if (textVariant === 'you-save-x') {
        var _eligibleDiscount_amount1;
        if (eligibleDiscount === null || eligibleDiscount === void 0 ? void 0 : (_eligibleDiscount_amount1 = eligibleDiscount.amount) === null || _eligibleDiscount_amount1 === void 0 ? void 0 : _eligibleDiscount_amount1.usd) {
            label = t('deviationview.thumb.discountLabel.youSave', {
                dollarAnmount: formattedEligibleDiscountDollarAmount
            });
        }
    }
    if (!label) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], className)
    }, label);
};
DeviationThumbDiscountLabel.displayName = 'DeviationThumbDiscountLabel';
export default DeviationThumbDiscountLabel;

//# sourceMappingURL=DeviationThumbDiscountLabel.js.map